/** Instant SSR placeholder — replaced by Lottie after idle on the client. */
export function HourglassMarkStatic() {
  return (
    <div
      className="mobile-blocker-hourglass-placeholder"
      aria-hidden
      style={{ width: 42, height: 42 }}
    />
  );
}
